import React, { useEffect } from 'react';
import Pagination from '../../../../../../../components/common/pagination';
import { debounce } from 'lodash';
import SmartFilter from '../../../../../../../components/common/smartFilter';
import SingleUserLayout from '../../SingleUserLayout';
import UserTerminalDetails from './TerminalDetailsIndex';
import { UserTerminalDetail } from './TerminalDetailsIndex';
import { useNavigate } from 'react-router-dom';
import { ALL_ROUTES } from '../../../../../../../routes/dashboard/overview/AllPathNames';
import { useDispatch } from 'react-redux';
import { bankboxAPI } from '../../../../../../../redux/bankbox';

const UserTerminals = () => {
	// const dispatch = useDispatch();
	// const navigate = useNavigate();
	// const merchant_email =
	// 	localStorage?.getItem('merchant-email-user-preview') || '';

	// useEffect(() => {
	// 	if (merchant_email) {
	// 		getMerchantBankboxes(merchant_email);
	// 	} else {
	// 		navigate(ALL_ROUTES?.BANKBOX_USER);
	// 	}
	// }, []);

	// const getMerchantBankboxes = async (mail?: any) => {
	// 	const data = await dispatch(
	// 		bankboxAPI.getAllBankBoxForMerchant({
	// 			per_page: 20,
	// 			page: 1,
	// 			email: mail,
	// 		})
	// 	);
	// };

	return (
		<div>
			<div>
				<UserTerminalDetails />
			</div>
		</div>
	);
};

export default UserTerminals;
